export const CLOUDFRONT = process.env.NEXT_PUBLIC_CLOUDFRONT_DOMAIN;

export const ASSETS_LINK = `https://${CLOUDFRONT}`;
export const USER_DEFAULT_AVATAR = "/images/avatar-placeholder.png";

export const BREAKPOINTS = {
  xxs: "320px",
  xs: "360px",
  sm: "480px",
  md: "768px",
  lg: "976px",
  tablet: "1024px",
  tablet2: "1080px",
  xl: "1280px",
  "2xl": "1280px",
  "3xl": "1280px",
  "4xl": "1280px",
};

export const PRIVACY_PAGE = "/legal/privacy";
export const TERMS_PAGE = "/legal/terms";

export const BLOG_LINK = "https://graphy.com/blog";

export const HELP_LINK = "https://help.graphy.com/";

export const ROADMAP_LINK = "https://feedback.graphy.com/roadmap";

export const UPDATES_LINK = "https://updates.graphy.com/";

export const INSTRUCTOR_STEP_INDEX = {
  CREATE_ACCOUNT: "CREATE_ACCOUNT",
  VERIFICATION_LINK_SENT: "VERIFICATION_LINK_SENT",
  SELECT_SCHOOL_TYPE: "SELECT_SCHOOL_TYPE",
  UPLOAD_AVATAR: "UPLOAD_AVATAR",
  ADD_PROFILE_DETAILS: "ADD_PROFILE_DETAILS",
  LOGIN: "LOGIN",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
};

export const APP_STORE_LINK =
  "https://apps.apple.com/in/app/graphy-learning-communities/id1562467584";

export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.graphy";
export const MARKETING_PAGES_DOMAIN =
  process.env.NEXT_PUBLIC_MARKETING_PAGES_S3_DOMAIN;
